/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { PortalTopArchiveEventsFetcher } from "features/PortalTopArchiveEvents";
import { PortalTopUpcomingEventsFetcher } from "features/PortalTopUpcomingEvents";
import React from "react";

import { divStyle, rootStyle } from "./styles";

export const PortalInitialEventDisplay = () => {
  return (
    <div css={rootStyle}>
      {/* Archive */}
      <div css={divStyle}>
        <PortalTopArchiveEventsFetcher />
      </div>
      {/* Upcoming Event */}
      <div css={divStyle}>
        <PortalTopUpcomingEventsFetcher />
      </div>
    </div>
  );
};
